module.exports = __webpack_public_path__ + "img/dsci0066.2653f5a9.jpg";